import googlePolyline                                                   from 'google-polyline'
import {LOCALITY_POLY_OPTIONS, MAP, POPUP_AUTO_PAN, POPUP_KEEP_IN_VIEW} from "../../config/map"
import {map as mapEndpoints}                                            from '../../api/api-endpoints'
import store                                                            from '../../store'
import Vue                                                              from 'vue'
import MapEquidistant                                                   from "@/utils/map/popup/MapEquidistant";
import PopupCreator                                                     from "@/utils/map/PopupCreator";
import {OBJECT}                                                         from "@/utils/map/types";
import L                                                                from 'leaflet'

class BorderDrawer {
  constructor (map, vm) {
    this.mainBorderPolygons = []
    this.mainBorderLayer = null
    this.map = map
    this.color = false
    this.__polygons = {};
    this.__eqPolygon = null;
    this.vm = vm
    this.map.on('zoom', this.onZoomChange.bind(this))
    this.popUpCreator = new PopupCreator(this.vm);
  }

  dropVueWatchers (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  getMainBorderPolygonsCoords () {
    return this.mainBorderPolygons
  }

  onZoomChange () {
    const zoom = this.map.getZoom()
    const endpoint = mapEndpoints.heatMapRegOperators(zoom)

    if (this.lastDrawedEndpoint === endpoint) {
      return
    }

    this.lastDrawedEndpoint = endpoint
    store.dispatch('updateUrlEndpoint', {
      endpoint,
      fromCache: true,
      params: {
        disableGlobalError: true
      }
    }).catch(e => {
      console.warn('')
      console.error(e)
    })
  }

  /**
   * @param mixedPolygonFormat
   * @param borders
   * @param options
   */
  drawAll (mixedPolygonFormat, borders = {}, options = {}) {
    this.drawMainBorder(
      this.parseMainBorderPolygons(mixedPolygonFormat),
      true,
      true
    )
  }

  parseMainBorderPolygons (mixedPolygonFormat) {
    let polygons = []
    if (Array.isArray(mixedPolygonFormat)) {
      polygons.push(mixedPolygonFormat)
    } else if (typeof mixedPolygonFormat === 'string') {
      polygons.push(
        googlePolyline.decode(decodeURI(mixedPolygonFormat))
      )
    } else {
      if (mixedPolygonFormat.type !== 'GeometryCollection') {
        console.error('Support only GeometryCollection geojson format')
      } else {
        console.warn('GeoJSON only partial support')
        mixedPolygonFormat.geometries.forEach((geoCol, i) => {
          mixedPolygonFormat.geometries[i].coordinates.forEach(v => {
            if (typeof v === 'string') {
              polygons.push(googlePolyline.decode(decodeURI(v)))
            } else {
              let invertedCoords = v.map(coords => coords.map(([lat, lng]) => [lng, lat]))
              polygons.push(invertedCoords)
            }
          })
        })
      }
    }
    return polygons
  }

  drawMainBorder (polygons, sub, color) {
    this.mainBorderPolygons = []
    if (this.mainBorderLayer) {
      this.mainBorderLayer.remove()
    }
    try {
      this.mainBorderLayer = L.layerGroup()
      this.mainBorderLayer.addTo(this.map)
      polygons.forEach(polygon => {
        this.mainBorderPolygons.push(polygon)
        const poly = L.polygon(polygon, {
          color: '#e4827f',
          fillColor: '#e4827f',
          fillOpacity: color ? 0 : 0.1,
          weight: 2
        })
        this.mainBorderLayer.addLayer(
          poly
        )
      })
    } catch (e) {
      console.error(e)
    }
  }

  _getPolygons (item) {
    let coords = []
    try {
      if (Array.isArray(item?.polygon)) {
        coords = item.polygon
      } else if (item?.polygon) {
        let parsed = JSON.parse(item?.polygon)
        if (!Array.isArray(parsed)) {
          throw new Error('Неверный формат полигона у ' + item.name)
        }
        coords = parsed
      } else if (item?.geojson) {
        const poly = JSON.parse(item?.geojson)
        //конечно, и данные должны быть в порядке: сюда не должны попадать НЕполигоны, но мы живем не в идеальном мире...
        if (poly?.type !== 'Polygon' && poly?.type !== 'MultiPolygon') {
          return []
        }
        coords = this.revertCoors(poly?.coordinates || [])
      }
    } catch (e) {
      console.error(e)
    }
    return coords
  }

  revertCoors (points) {
    if (!points?.length) {
      return points
    }
    if (typeof points[0] === 'number') {
      return [points[1], points[0]]
    }
    return points.map(v => {
      if (v.length === 2) {
        return [v[1], v[0]]
      } else {
        return this.revertCoors(v)
      }
    })
  }

  removeLocality () {
    for (let key in this.__polygons) {
      this.__polygons[key].remove()
    }
    this.__polygons = {}
  }
  drawLocality (inputData, color) {
    this.color = color
    try {
      this.removeLocality()
      let data = this.dropVueWatchers(inputData || {data:[]})
      const items = data.data || data
      items.forEach((item, i)=> {
        let fillOpacity = 0.5
        if (item.opacity && color === true) {
          fillOpacity = item.opacity
        }
        const polygons = this._getPolygons(item)
        if (!polygons.length) {
          return
        }
        this.__polygons[i] = L.polygon(polygons, {
          ...LOCALITY_POLY_OPTIONS,
          fillColor: item.color,
          fillOpacity,
        }).addTo(this.map)
        this.__polygons[i].options.item = item
        this.__polygons[i].on('click', () => this.vm.$emitter.emit('eqClickPolygon', item))
      })
    } catch (e) {
      console.error(e)
    }
  }

  async clearEqPoly() {
    if (this.__eqPolygon) {
      this.__eqPolygon.remove();
    }
  }

  drawPolygon(polygon) {
    const polygons = this._getPolygons(polygon)
    if (!polygons.length) {
      return
    }
    this.__eqPolygon = L.polygon(polygons, {
      color: "rgba(1, 2, 0, 0.3)",
      weight: 10,
    }).addTo(this.map);
  }

  addEqPolygonClick(id, radius) {
    this.__eqPolygon.on('click',(event) => {
      let options = {
        redirectParams: {
          name: 'equidistant.object.geo',
          query: {
            id,
            radius
          }
        }
      }
      let popup = this.popUpCreator.getPopup(
        this.__eqPolygon,
        OBJECT.EQUIDISTANT,
        null,
        options
      )
      this.__eqPolygon.bindPopup(popup).openPopup()
    });
  }

  afterDrawLocality () {
    for (let key in this.__polygons) {
      this.__polygons[key].bringToBack()
    }
  }
}

export default BorderDrawer
